'use es6';

import { Map as ImmutableMap } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';
import setIn from 'transmute/setIn';
import { succeeded } from '../../constants/asyncStatuses';
import { getResponders } from '../../responders/selectors/getResponders';
import { getResponderAsSender } from '../operators/getResponderAsSender';
import { getResponderKeyAsSenderLocator } from '../operators/getResponderKeyAsSenderLocator';
export const getSendersMap = createSelector([getResponders], respondersMap => {
  return respondersMap.reduce((sendersMap, responder, responderKey) => {
    return setIn([getResponderKeyAsSenderLocator(responderKey)], succeeded(responder ? getResponderAsSender(responder) : null), sendersMap);
  }, ImmutableMap());
});